import QRCode from "qrcode";
import { useEffect, useState } from "react";

/** QR code as inline SVG (dark modules on a light rounded card). */
export function QR({ value, size = 180, label }: { value: string; size?: number; label?: string }) {
  const [svg, setSvg] = useState<string>("");
  useEffect(() => {
    let alive = true;
    QRCode.toString(value, { type: "svg", margin: 1, errorCorrectionLevel: "M", color: { dark: "#1a0a31", light: "#fff6ee" } })
      .then((s) => alive && setSvg(s))
      .catch(() => setSvg(""));
    return () => {
      alive = false;
    };
  }, [value]);
  return (
    <div
      role="img"
      aria-label={label ?? value}
      className="overflow-hidden rounded-[18px] bg-ink p-2"
      style={{ width: size, height: size }}
      dangerouslySetInnerHTML={{ __html: svg.replace("<svg ", '<svg width="100%" height="100%" ') }}
    />
  );
}
